import { Button, FormControl, Grid, Paper, TextField } from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import { Formik } from "formik";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { object, string } from "yup";
import { getTextSetting, updateTextSetting } from "../../../../api/textSettingApi";
import { useForceRender } from "../../../../utils/customHook";
import { useSelector } from "react-redux";

export default function TextSetting() {
    const [render, forceRender] = useForceRender();

    // ref
    const controllerRef = useRef(null);

    // global redux state
    const { thisMenuPermission } = useSelector(state => {
        const { menuPermission } = state?.menu;
        return {
            thisMenuPermission: menuPermission?.find(menu => menu?.path === window.location.pathname)?.permission,
        };
    });

    // conponent state
    const [initialFormValues, setInitialFormValues] = useState({
        text: "",
        medicineText: "",
        cashierText: "",
    });

    const handleSaveTextSetting = useCallback(
        async values => {
            try {
                const isUpdate = await updateTextSetting(
                    { text: values?.text, medicineText: values?.medicineText, cashierText: values?.cashierText },
                    controllerRef.current?.signal,
                );
                if (isUpdate) {
                    forceRender();
                }
            } catch (error) {
                console.dir(error);
            }
        },
        [forceRender],
    );

    // run only first render
    useEffect(() => {
        controllerRef.current = new AbortController();
        const init = async () => {
            try {
                const res = await getTextSetting(controllerRef.current?.signal);
                if (res) {
                    setInitialFormValues({
                        text: res?.text,
                        medicineText: res?.medicineText,
                        cashierText: res?.cashierText,
                    });
                }
            } catch (error) {
                console.dir(error);
            }
        };
        init();
        // to avoid memory leaked.
        return () => {
            controllerRef.current.abort();
        };
    }, [render]);

    return (
        <Grid container spacing={0}>
            <Grid item xs={12} className="mb-5 mb-sm-10">
                <h1 className="t-text-primary">Text Setting</h1>
            </Grid>

            {/* content */}
            <Grid item xs={12}>
                <Paper className="py-5 py-md-10 shadow-none">
                    <Formik
                        enableReinitialize
                        validationSchema={object({
                            text: string().required("Required."),
                            medicineText: string().required("Required."),
                            cashierText: string().required("Required."),
                        })}
                        initialValues={initialFormValues}
                        onSubmit={handleSaveTextSetting}>
                        {({ values, errors, handleChange, handleSubmit }) => (
                            <Grid container className="justify-content-center">
                                <Grid item xs={12} className=" d-flex justify-content-center align-items-center mb-5">
                                    <Grid item xs={12} md={5} className="px-10">
                                        <label>พิมพ์ข้อความที่ต้องการ (Doctor Display)</label>
                                        <FormControl className="t-form-group-custom w-100">
                                            <TextField
                                                className={`h-100`}
                                                InputProps={{
                                                    endAdornment: <Edit />,
                                                }}
                                                fullWidth
                                                size="small"
                                                type="text"
                                                name="text"
                                                label="ข้อความ"
                                                variant="outlined"
                                                value={values?.text}
                                                onChange={handleChange}
                                                error={Boolean(errors.text)}
                                                helperText={errors.text}
                                                FormHelperTextProps={{
                                                    className: "text-danger position-absolute",
                                                    style: { bottom: -25, left: -12 },
                                                }}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className=" d-flex justify-content-center align-items-center mb-5">
                                    <Grid item xs={12} md={5} className="px-10">
                                        <label>พิมพ์ข้อความที่ต้องการ (Medicine Display)</label>
                                        <FormControl className="t-form-group-custom w-100">
                                            <TextField
                                                className={`h-100`}
                                                InputProps={{
                                                    endAdornment: <Edit />,
                                                }}
                                                fullWidth
                                                size="small"
                                                type="text"
                                                name="medicineText"
                                                label="ข้อความ"
                                                variant="outlined"
                                                value={values?.medicineText}
                                                onChange={handleChange}
                                                error={Boolean(errors?.medicineText)}
                                                helperText={errors?.medicineText}
                                                FormHelperTextProps={{
                                                    className: "text-danger position-absolute",
                                                    style: { bottom: -25, left: -12 },
                                                }}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} className=" d-flex justify-content-center align-items-center">
                                    <Grid item xs={12} md={5} className="px-10">
                                        <label>พิมพ์ข้อความที่ต้องการ (Cashier Display)</label>
                                        <FormControl className="t-form-group-custom w-100">
                                            <TextField
                                                className={`h-100`}
                                                InputProps={{
                                                    endAdornment: <Edit />,
                                                }}
                                                fullWidth
                                                size="small"
                                                type="text"
                                                name="cashierText"
                                                label="ข้อความ"
                                                variant="outlined"
                                                value={values?.cashierText}
                                                onChange={handleChange}
                                                error={Boolean(errors?.cashierText)}
                                                helperText={errors?.cashierText}
                                                FormHelperTextProps={{
                                                    className: "text-danger position-absolute",
                                                    style: { bottom: -25, left: -12 },
                                                }}
                                            />
                                        </FormControl>
                                    </Grid>
                                </Grid>
                                {thisMenuPermission?.create && thisMenuPermission?.edit && (
                                    <Grid item xs={12}>
                                        <Grid container className="justify-content-center">
                                            <Grid item xs={12} md={5} className="px-10">
                                                <div className="d-flex justify-content-end mt-5 mt-md-10">
                                                    <Button onClick={handleSubmit} className="t-btn-primary">
                                                        Save
                                                    </Button>
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )}
                            </Grid>
                        )}
                    </Formik>
                </Paper>
            </Grid>
        </Grid>
    );
}
